// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components';
import keys from 'lodash/keys';
import orderBy from 'lodash/orderBy';

export const sizes = {
  tablet: 1024,
  phone: 480,
};

const parseSupportedMedia = () => {
  const sortedSizes = orderBy(sizes, 'asc');
  const s = keys(sizes).map(size => ({
    key: size,
    query: `(max-width: ${sizes[size]}px)`,
  }));
  return [
    {
      key: 'desktop',
      query: `(min-width: ${sortedSizes[0] + 1}px)`,
    },
  ].concat(s);
};

export const supportedMedia = parseSupportedMedia();

// iterate through the sizes and create a media template
const media = keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});

export default media;



// WEBPACK FOOTER //
// ./src/styles/media.js